export const OPEN_FILTERS = { is_open: { value: true } };
